import React, {useState} from 'react';
import { TextdomainContext, buildTextdomain } from 'react-gettext';

import MainPage from "./components/MainPage";
import './App.css';

const App: React.FC = () => {

  const [language, setLanguage] = useState('nb_NO');

  /**
   * @param langCode string eg nb-NO
   */
  const selectLanguage = (langCode: string) => {
    setLanguage(langCode);
  };

  let poFile: translationsType = {
    catalog: {},
    plural: 'n != 1',
  };

  try {
    // eslint-disable-next-line global-require,import/no-dynamic-require
    poFile = require(`./languages/LC_MESSAGES/${language}.mo.json`);
  }
  catch (e) {
    // do nothing, default poFile will be used
  }

  const textDomain: TextdomainContext = buildTextdomain(poFile.catalog, poFile.plural);
  return (
      <TextdomainContext.Provider value={textDomain}>
        <MainPage selectLang={selectLanguage} />
      </TextdomainContext.Provider>
  );
};

export default App;
